module.exports = __webpack_public_path__ + "img/edge_divers_by_night.c9d83805.svg";